// extracted by css-extract-rspack-plugin
export default {"actionButton":"Dialog_actionButton__wlAw1","dialogTitle":"Dialog_dialogTitle__o1urx","dialogContent":"Dialog_dialogContent__yANsE","table":"Dialog_table__XhNkZ"};